import React, { useEffect, useState } from "react"
import { addBEMsg, JSONParse, makeid, newGroup } from 'src/_helpers'
import { DirectMessagingBEService } from 'src/_services'
export const Control = () => {
  var [socket, setSocket] = useState(null);
  useEffect(() => {
    new DirectMessagingBEService().join(makeid(150)).then(({ data }) => {
      initWebSocket(data)
    }).catch(e => console.log(e))
  }, []);
  const initWebSocket = (token) => {
    if (token && socket && !socket.url.includes(token)) {
      socket.close()
    }
    let url = `wss://imonqr.com:9999/ws/${token}`
    var initsocket = new WebSocket(url)
    setSocket(initsocket)
    initsocket.onopen = (e) => {
      console.log('WebSocket is opening', e)
    }

    initsocket.onmessage = (e) => {
      addBEMsg(JSONParse(e.data))
      newGroup(JSONParse(e.data))
    }
    initsocket.onclose = (e) => {
      console.log('onclose', e)
      setTimeout(() => { initWebSocket(token) }, 5000)
    }
    initsocket.onerror = (e) => {
      console.log('Network is offline', e)
    }
  }
  return <>...</>;
};
